import { render } from "./MenuCategorie.vue?vue&type=template&id=4985df8e&scoped=true&ts=true"
import script from "./MenuCategorie.vue?vue&type=script&lang=ts"
export * from "./MenuCategorie.vue?vue&type=script&lang=ts"

import "./MenuCategorie.vue?vue&type=style&index=0&id=4985df8e&scoped=true&lang=css"

import exportComponent from "C:\\htdocs\\sputnik\\vue\\verdura-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4985df8e"]])

export default __exports__